module.exports = __webpack_public_path__ + "img/d.a928b198.png";